function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

const escapeQuotes = (text) => text.replace(/['"]/g, '\\$&')

document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
  e.setAttribute('role', 'link'),
    e.setAttribute('aria-expanded', 'false'),
    e.nextElementSibling.getAttribute('id') && e.setAttribute('aria-controls', e.nextElementSibling.id),
    e.addEventListener('click', (e) => {
      e.currentTarget.setAttribute('aria-expanded', !e.currentTarget.closest('details').hasAttribute('open'))
    }),
    e.closest('header-drawer') || e.parentElement.addEventListener('keyup', onKeyUpEscape)
})
const trapFocusHandlers = {}
function trapFocus(e, t = e) {
  var i = getFocusableElements(e),
    n = i[0],
    s = i[i.length - 1]
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      ;(t.target !== e && t.target !== s && t.target !== n) || document.addEventListener('keydown', trapFocusHandlers.keydown)
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown)
    }),
    (trapFocusHandlers.keydown = function (t) {
      'TAB' === t.code.toUpperCase() &&
        (t.target !== s || t.shiftKey || (t.preventDefault(), n.focus()),
        (t.target !== e && t.target !== n) || !t.shiftKey || (t.preventDefault(), s.focus()))
    }),
    document.addEventListener('focusout', trapFocusHandlers.focusout),
    document.addEventListener('focusin', trapFocusHandlers.focusin),
    t.focus()
}
try {
  document.querySelector(':focus-visible')
} catch {
  focusVisiblePolyfill()
}
function focusVisiblePolyfill() {
  const e = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ]
  let t = null,
    i = null
  window.addEventListener('keydown', (t) => {
    e.includes(t.code.toUpperCase()) && (i = !1)
  }),
    window.addEventListener('mousedown', (e) => {
      i = !0
    }),
    window.addEventListener(
      'focus',
      () => {
        t && t.classList.remove('focused'), i || ((t = document.activeElement), t.classList.add('focused'))
      },
      !0
    )
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((e) => {
    e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
  }),
    document.querySelectorAll('.js-vimeo').forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', '*')
    }),
    document.querySelectorAll('video').forEach((e) => e.pause()),
    document.querySelectorAll('product-model').forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause()
    })
}
function removeTrapFocus(e = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin),
    document.removeEventListener('focusout', trapFocusHandlers.focusout),
    document.removeEventListener('keydown', trapFocusHandlers.keydown),
    e && e.focus()
}
function onKeyUpEscape(e) {
  if ('ESCAPE' !== e.code.toUpperCase()) return
  const t = e.target.closest('details[open]')
  if (!t) return
  const i = t.querySelector('summary')
  t.removeAttribute('open'), i.setAttribute('aria-expanded', !1), i.focus()
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector('input')),
      this.input.addEventListener('change', this.onChangeInput.bind(this)),
      (this.changeEvent = new Event('change', { bubbles: !0 })),
      this.querySelectorAll('button').forEach((e) => e.addEventListener('click', this.onButtonClick.bind(this))),
      this.checkAndDisableMinusButton()
  }
  onButtonClick(e) {
    e.preventDefault()
    const t = this.input.value
    'plus' === e.target.name ? this.input.stepUp() : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent)
  }
  onChangeInput() {
    this.checkAndDisableMinusButton(!0), this.input.value < 1 ? this.toggleAddButton() : this.toggleAddButton(!1)
  }
  toggleAddButton(e = !0) {
    const t = this.input.form,
      i = t.querySelector('[name="add"] > span')?.innerText
    if (!t || 'SOLD OUT ONLINE' == i || 'UNAVAILABLE' == i) return
    const n = t.querySelector('[name="add"]')
    n && (e ? n.setAttribute('disabled', 'disabled') : n.removeAttribute('disabled'))
  }
  checkAndDisableMinusButton(e = !1) {
    const t = this.querySelector('button[name="minus"]')
    t && (this.input.value === this.input.min ? (e && this.input.focus(), (t.disabled = !0)) : t.disabled && (t.disabled = !1))
  }
}
function debounce(e, t) {
  let i
  return (...n) => {
    clearTimeout(i), (i = setTimeout(() => e.apply(this, n), t))
  }
}
function fetchConfig(e = 'json') {
  return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/${e}` } }
}
customElements.define('quantity-input', QuantityInput),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments)
    }
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, n = e.options.length; i < n; i++) {
      var s = e.options[i]
      if (t == s.value || t == s.innerHTML) return (e.selectedIndex = i), i
    }
  }),
  (Shopify.addListener = function (e, t, i) {
    e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent('on' + t, i)
  }),
  (Shopify.postLink = function (e, t) {
    var i = (t = t || {}).method || 'post',
      n = t.parameters || {},
      s = document.createElement('form')
    for (var a in (s.setAttribute('method', i), s.setAttribute('action', e), n)) {
      var r = document.createElement('input')
      r.setAttribute('type', 'hidden'), r.setAttribute('name', a), r.setAttribute('value', n[a]), s.appendChild(r)
    }
    document.body.appendChild(s), s.submit(), document.body.removeChild(s)
  }),
  (Shopify.CountryProvinceSelector = function (e, t, i) {
    ;(this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(i.hideElement || t)),
      Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this)),
      this.initCountry(),
      this.initProvince()
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute('data-default')
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler()
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute('data-default')
      e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e)
    },
    countryHandler: function (e) {
      var t = (s = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute('data-provinces'),
        i = JSON.parse(t)
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = 'none'
      else {
        for (var n = 0; n < i.length; n++) {
          var s
          ;((s = document.createElement('option')).value = i[n][0]), (s.innerHTML = i[n][1]), this.provinceEl.appendChild(s)
        }
        this.provinceContainer.style.display = ''
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild; ) e.removeChild(e.firstChild)
    },
    setOptions: function (e, t) {
      var i = 0
      for (t.length; i < t.length; i++) {
        var n = document.createElement('option')
        ;(n.value = t[i]), (n.innerHTML = t[i]), e.appendChild(n)
      }
    },
  })
class MenuDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector('details')),
      'iPhone' === navigator.platform &&
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`),
      this.addEventListener('keyup', this.onKeyUp.bind(this)),
      this.addEventListener('focusout', this.onFocusOut.bind(this)),
      this.bindEvents()
  }
  bindEvents() {
    this.querySelectorAll('summary').forEach((e) => e.addEventListener('click', this.onSummaryClick.bind(this))),
      this.querySelectorAll('button').forEach((e) => e.addEventListener('click', this.onCloseButtonClick.bind(this))),
      this.querySelector('.menu-drawer-overlay').addEventListener('click', this.onCloseButtonClick.bind(this))
  }
  onKeyUp(e) {
    if ('ESCAPE' !== e.code.toUpperCase()) return
    const t = e.target.closest('details[open]')
    t &&
      (t === this.mainDetailsToggle
        ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector('summary'))
        : this.closeSubmenu(t))
  }
  onSummaryClick(e) {
    const t = e.currentTarget,
      i = t.parentNode,
      n = i.hasAttribute('open'),
      s = window.matchMedia('(prefers-reduced-motion: reduce)')
    function a() {
      trapFocus(t.nextElementSibling, i.querySelector('button')), t.nextElementSibling.removeEventListener('transitionend', a)
    }
    i === this.mainDetailsToggle
      ? (n && e.preventDefault(), n ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t))
      : setTimeout(() => {
          i.classList.add('menu-opening'),
            t.setAttribute('aria-expanded', !0),
            !s || s.matches ? a() : t.nextElementSibling.addEventListener('transitionend', a)
        }, 100)
  }
  openMenuDrawer(e) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    }),
      e.setAttribute('aria-expanded', !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
  closeMenuDrawer(e, t = !1) {
    void 0 !== e &&
      (this.mainDetailsToggle.classList.remove('menu-opening'),
      this.mainDetailsToggle.querySelectorAll('details').forEach((e) => {
        e.removeAttribute('open'), e.classList.remove('menu-opening')
      }),
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
      removeTrapFocus(t),
      this.closeAnimation(this.mainDetailsToggle))
  }
  onFocusOut(e) {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer()
    })
  }
  onCloseButtonClick(e) {
    const t = e.currentTarget.closest('details')
    this.closeSubmenu(t)
  }
  closeSubmenu(e) {
    e.classList.remove('menu-opening'),
      e.querySelector('summary').setAttribute('aria-expanded', !1),
      removeTrapFocus(),
      this.closeAnimation(e)
  }
  closeAnimation(e) {
    let t
    const i = (n) => {
      void 0 === t && (t = n)
      n - t < 400
        ? window.requestAnimationFrame(i)
        : (e.removeAttribute('open'),
          e.closest('details[open]') && trapFocus(e.closest('details[open]'), e.querySelector('summary')))
    }
    window.requestAnimationFrame(i)
  }
}
customElements.define('menu-drawer', MenuDrawer)
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
  }
  openMenuDrawer(e) {
    ;(this.header = this.header || document.getElementById('shopify-section-header')),
      (this.borderOffset =
        this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0),
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      ),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening')
      }),
      e.setAttribute('aria-expanded', !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
}
customElements.define('header-drawer', HeaderDrawer)
class ModalDialog extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, !1)),
      this.addEventListener('keyup', (e) => {
        'ESCAPE' === e.code.toUpperCase() && this.hide()
      }),
      this.classList.contains('media-modal')
        ? this.addEventListener('pointerup', (e) => {
            'mouse' !== e.pointerType || e.target.closest('deferred-media, product-model') || this.hide()
          })
        : this.addEventListener('click', (e) => {
            e.target === this && this.hide()
          })
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this))
  }
  show(e) {
    this.openedBy = e
    const t = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden'),
      this.setAttribute('open', ''),
      t && t.loadContent(),
      document.body.dispatchEvent(new CustomEvent('modalOpened')),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia(),
      this.classList.contains('autoplay') &&
        (this.classList.contains('youtube')
          ? (document.querySelector('.js-youtube').src += '&autoplay=1')
          : (document.querySelector('.js-vimeo').src += '?autoplay=1'))
  }
  hide() {
    document.body.classList.remove('overflow-hidden'),
      document.body.dispatchEvent(new CustomEvent('modalClosed')),
      this.removeAttribute('open'),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia()
  }
}
customElements.define('modal-dialog', ModalDialog)
class ModalOpener extends HTMLElement {
  constructor() {
    super()
    const e = this.querySelector('button')
    e &&
      e.addEventListener('click', () => {
        const t = document.querySelector(this.getAttribute('data-modal'))
        t && t.show(e)
      })
  }
}
customElements.define('modal-opener', ModalOpener)
class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    const e = this.querySelector('[id^="Deferred-Poster-"]')
    e && e.addEventListener('click', this.loadContent.bind(this))
  }
  loadContent(e = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute('loaded'))) {
      const t = document.createElement('div')
      t.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(!0)), this.setAttribute('loaded', !0)
      const i = this.appendChild(t.querySelector('video, model-viewer, iframe'))
      e && i.focus()
    }
  }
}
customElements.define('deferred-media', DeferredMedia)
class SliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector('.slider-counter--current')),
      (this.pageTotalElement = this.querySelector('.slider-counter--total')),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      !this.slider || !this.nextButton)
    )
      return
    this.initPages()
    new ResizeObserver((e) => this.initPages()).observe(this.slider),
      this.slider.addEventListener('scroll', this.resetPages.bind(this)),
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this)),
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this))
  }
  initPages() {
    ;(this.sliderItemsToShow = Array.from(this.sliderItems).filter((e) => e.clientWidth > 0)),
      (this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1]),
      0 !== this.sliderItemsToShow.length &&
        ((this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth)),
        (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update())
  }
  resetPages() {
    ;(this.sliderItems = this.querySelectorAll('[id^="Slide-"]')), this.initPages()
  }
  update() {
    const e = this.currentPage
    ;(this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage), (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != e &&
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: { currentPage: this.currentPage, currentElement: this.sliderItemsToShow[this.currentPage - 1] },
          })
        ),
      this.enableSliderLooping ||
        (this.isSlideVisible(this.sliderItemsToShow[0])
          ? this.prevButton.setAttribute('disabled', 'disabled')
          : this.prevButton.removeAttribute('disabled'),
        this.isSlideVisible(this.sliderLastItem)
          ? this.nextButton.setAttribute('disabled', 'disabled')
          : this.nextButton.removeAttribute('disabled'))
  }
  isSlideVisible(e, t = 0) {
    const i = this.slider.clientWidth + this.slider.scrollLeft - t
    return e.offsetLeft + e.clientWidth <= i && e.offsetLeft >= this.slider.scrollLeft
  }
  onButtonClick(e) {
    e.preventDefault()
    const t = e.currentTarget.dataset.step || 1
    ;(this.slideScrollPosition =
      'next' === e.currentTarget.name
        ? this.slider.scrollLeft + t * this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - t * this.sliderLastItem.clientWidth),
      this.slider.scrollTo({ left: this.slideScrollPosition })
  }
}
customElements.define('slider-component', SliderComponent)
class SlideshowComponent extends SliderComponent {
  constructor() {
    super(),
      (this.sliderControlWrapper = this.querySelector('.slider-buttons')),
      (this.enableSliderLooping = !0),
      this.sliderControlWrapper &&
        ((this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide')),
        this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
        (this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'))),
        this.sliderControlLinksArray.forEach((e) => e.addEventListener('click', this.linkToSlide.bind(this))),
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this)),
        this.setSlideVisibility(),
        'true' === this.slider.getAttribute('data-autoplay') && this.setAutoPlay())
  }
  setAutoPlay() {
    ;(this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay')),
      (this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this)),
      this.addEventListener('mouseover', this.focusInHandling.bind(this)),
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this)),
      this.addEventListener('focusin', this.focusInHandling.bind(this)),
      this.addEventListener('focusout', this.focusOutHandling.bind(this)),
      this.play(),
      (this.autoplayButtonIsSetToPlay = !0)
  }
  onButtonClick(e) {
    super.onButtonClick(e)
    const t = 1 === this.currentPage,
      i = this.currentPage === this.sliderItemsToShow.length
    ;(t || i) &&
      (t && 'previous' === e.currentTarget.name
        ? (this.slideScrollPosition =
            this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length)
        : i && 'next' === e.currentTarget.name && (this.slideScrollPosition = 0),
      this.slider.scrollTo({ left: this.slideScrollPosition }))
  }
  update() {
    super.update(),
      (this.sliderControlButtons = this.querySelectorAll('.slider-counter__link')),
      this.prevButton.removeAttribute('disabled'),
      this.sliderControlButtons.length &&
        (this.sliderControlButtons.forEach((e) => {
          e.classList.remove('slider-counter__link--active'), e.removeAttribute('aria-current')
        }),
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active'),
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', !0))
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay)
  }
  focusOutHandling(e) {
    const t = e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target)
    this.autoplayButtonIsSetToPlay && !t && this.play()
  }
  focusInHandling(e) {
    ;(e.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(e.target)) && this.autoplayButtonIsSetToPlay
      ? this.play()
      : this.autoplayButtonIsSetToPlay && this.pause()
  }
  play() {
    this.slider.setAttribute('aria-live', 'off'),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed))
  }
  pause() {
    this.slider.setAttribute('aria-live', 'polite'), clearInterval(this.autoplay)
  }
  togglePlayButtonState(e) {
    e
      ? (this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused'),
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow))
      : (this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused'),
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow))
  }
  autoRotateSlides() {
    const e =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth
    this.slider.scrollTo({ left: e })
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach((e, t) => {
      const i = e.querySelector('a')
      t === this.currentPage - 1
        ? (i && i.removeAttribute('tabindex'), e.setAttribute('aria-hidden', 'false'), e.removeAttribute('tabindex'))
        : (i && i.setAttribute('tabindex', '-1'), e.setAttribute('aria-hidden', 'true'), e.setAttribute('tabindex', '-1'))
    })
  }
  linkToSlide(e) {
    e.preventDefault()
    const t =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(e.currentTarget) + 1 - this.currentPage)
    this.slider.scrollTo({ left: t })
  }
}
customElements.define('slideshow-component', SlideshowComponent)
class VariantSelects extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener('change', this.onVariantChange),
      (this.additionalVariantData = JSON.parse(document.getElementById('additionalVariantData').textContent)),
      this.setColorVariantLabel(),
      this.setPriceLabelAddButton(),
      this.updateVariantMetafieldImagesInitial(),
      this.updateOptions(),
      this.updateMasterId(),
      this.addOutOfStockClass(),
      this.getStoreAvailability(),
      this.updateVariantCopy()
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(!0, '', !1),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.setColorVariantLabel(),
      this.removeColorVariantLabel(),
      this.addOutOfStockClass(),
      this.updateStickyPrice(),
      this.currentVariant
        ? (this.updateMedia(),
          this.updateURL(),
          this.updateVariantInput(),
          this.updateShippingFeeMessage(),
          this.updateItemModel(),
          this.updateShippingMessage(),
          this.updateWarranties(),
          this.updateBogoProducts(),
          this.updateVariantMetafieldImages(),
          this.updateMaxVariantQuantity(),
          this.renderProductInfo(),
          this.updateShareUrl(),
          this.getStoreAvailability(),
          this.updateStickyPrice(),
          this.updateVariantCopy())
        : (this.toggleAddButton(!0, '', !0), this.setUnavailable())
  }
  updateVariantCopy() {
    document.getElementById('product-details__content').innerHTML =
      this.additionalVariantData[this.currentVariant.id]?.description
  }
  updateStickyPrice() {
    const e = document.getElementById('sticky-bar').querySelector('.price-item--regular')
    if (this.currentVariant) {
      const t = this.currentVariant.id,
        i = this.additionalVariantData[t]?.price,
        n = document.getElementById('Sticky-ATC-hidden-input')
      e.classList.remove('visibility-hidden'), (e.textContent = i), (n.value = t)
    } else e.classList.add('visibility-hidden')
  }
  getStoreAvailability() {
    const e = localStorage.getItem('storeSelected'),
      t = localStorage.getItem('storeSelectedId'),
      i = this.currentVariant.id,
      n = this.additionalVariantData[i]?.sku ?? this.additionalVariantData.productDefaultSku,
      s = document.getElementById(`store-availability-wrapper-${this.dataset.section}`),
      a = document.getElementById(`store-availability-message-${this.dataset.section}`)
    if (t && n)
      fetch(`https://wcsp-shopify.azurewebsites.net/product-availability?item=${n}&store=${t}`)
        .then((e) => e.json())
        .then((t) => {
          console.log(t),
            t.res[0]?.quantity ? (a.innerText = `Available at ${e}`) : (a.innerText = `Call ${e} for Availability`),
            s.classList.remove('hidden')
        })
    else {
      ;(a.innerHTML =
        '<a href="/pages/store-locator" class="store-locator-opener">Favorite a Store to See Pickup Availability</a>'),
        s.classList.remove('hidden')
      const e = document.querySelector('#store-locator-icon')
      document.querySelector('.store-locator-opener').addEventListener('click', (t) => {
        t.preventDefault(), e.click()
      })
    }
  }
  getParentMediaGallery(e) {
    let t = e.parentElement
    for (; t && 'MEDIA-GALLERY' !== t.tagName; ) t = t.parentElement
    return t
  }
  filterVariantImages(e) {
    let t = Object.values(document.querySelectorAll('[data-variant-image-url]'))
    const i = t.filter((t) => e.some((e) => e.includes(t.dataset.variantImageUrl)))
    i.forEach((e, t) => {
      const i = e.dataset.mediaId,
        n = document.querySelector('[id^="GalleryThumbnails"]')
      if (
        (n.querySelector(`[data-target="${i}"] button`).parentNode.classList.remove('hidden'),
        e.classList.remove('hidden'),
        0 == t)
      ) {
        e.classList.add('first-img'), e.classList.add('is-active')
        const t = this.getParentMediaGallery(e)
        t?.scrollToActive
          ? t.scrollToActive(e, i)
          : n.querySelector(`[data-target="${i}"] button`).setAttribute('aria-current', !0)
      }
    })
    t
      .filter((e) => !i.includes(e))
      .forEach((e) => {
        const t = e.dataset.mediaId,
          i = document.querySelector('[id^="GalleryThumbnails"]')
        i.querySelector(`[data-target="${t}"] button`).removeAttribute('aria-current'),
          e.classList.remove('is-active'),
          e.classList.contains('product__media-item--video') ||
            (e.classList.add('hidden'), i.querySelector(`[data-target="${t}"] button`).parentNode.classList.add('hidden'))
      }),
      e.length <= 6
        ? document.querySelectorAll('.thumbnail-slider .slider-button').forEach((e) => {
            e.classList.add('hidden')
          })
        : document.querySelectorAll('.thumbnail-slider .slider-button').forEach((e) => {
            e.classList.remove('hidden')
          })
  }
  updateVariantMetafieldImages() {
    if (0 != window.Resources.variantImageList) {
      let e = window.Resources.variantImageList,
        t = []
      null != this.currentVariant.option1 &&
        e.map((e) => {
          e[1].option1 == this.currentVariant.option1 &&
            (null != this.currentVariant.option2
              ? e[1].option2 == this.currentVariant.option2 &&
                (null != this.currentVariant.option3 ? e[1].option3 == this.currentVariant.option3 && t.push(e[0]) : t.push(e[0]))
              : t.push(e[0]))
        }),
        this.filterVariantImages(t)
    }
  }
  updateVariantMetafieldImagesInitial() {
    if (0 != window.Resources.variantImageList) {
      let e = window.Resources.variantImageList,
        t = document.querySelector('[data-current-variant-selected]').value,
        i = this.getVariantData().find((e) => e.id == t),
        n = []
      null != i.option1 &&
        e.map((e) => {
          e[1].option1 == i.option1 &&
            (null != i.option2
              ? e[1].option2 == i.option2 && (null != i.option3 ? e[1].option3 == i.option3 && n.push(e[0]) : n.push(e[0]))
              : n.push(e[0]))
        }),
        this.filterVariantImages(n)
    }
  }
  updateOptions() {
    let e = this.querySelectorAll('input')
    0 == e.length
      ? (this.options = Array.from(this.querySelectorAll('select'), (e) => e.value))
      : ((this.inputs = Array.from(e).find((e) => e.checked).value),
        (this.index = Number(document.querySelector('fieldset').getAttribute('node-index'))),
        (this.options = Array.from(this.querySelectorAll('select'), (e) => e.value)),
        this.options.splice(this.index, 0, this.inputs))
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((e) => !e.options.map((e, t) => this.options[t] === e).includes(!1))
  }
  addOutOfStockClass() {
    this.getVariantData().forEach((e) => {
      if (this.currentVariant && e.option2 === this.currentVariant.option2)
        if (e.available) {
          if (e.option1) {
            document.querySelector(`input[value='${escapeQuotes(e.option1)}']`).nextElementSibling.classList.remove('unavailable')
          }
          if (e.option3) {
            document.querySelector(`input[value='${escapeQuotes(e.option3)}']`).nextElementSibling.classList.remove('unavailable')
          }
        } else {
          if (e.option1) {
            document.querySelector(`input[value='${escapeQuotes(e.option1)}']`).nextElementSibling.classList.add('unavailable')
          }
          if (e.option3) {
            document.querySelector(`input[value='${escapeQuotes(e.option3)}']`).nextElementSibling.classList.add('unavailable')
          }
        }
    })
  }
  updateMedia() {
    if (0 == window.Resources.variantImageList) {
      if (!this.currentVariant) return
      if (!this.currentVariant.featured_media) return
      document
        .getElementById(`MediaGallery-${this.dataset.section}`)
        .setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !0)
      const e = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`),
        t = e.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`)
      e.prepend(t)
    }
  }
  updateVariantMedia() {
    if (0 == window.Resources.variantImageList) {
      let e = document.querySelectorAll('input[name=Color]'),
        t = document.querySelectorAll("select[name='options[Color]']"),
        i = document.querySelectorAll('.thumbnail-list__item img'),
        n = document.querySelectorAll('.product__media-item  img')
      e.length > 0
        ? e.forEach((e) => {
            e.checked &&
              (i.length > 0 &&
                i.forEach((t) => {
                  let i = e.value.split(' ').join('-').toLowerCase()
                  t.src.includes(i)
                    ? (t.parentElement.parentElement.style.display = 'block')
                    : (t.parentElement.parentElement.style.display = 'none')
                }),
              n.length > 0 &&
                n.forEach((t) => {
                  let i = e.value.split(' ').join('-').toLowerCase()
                  t.src.includes(i)
                    ? (t.parentElement.parentElement.parentElement.style.display = 'block')
                    : (t.parentElement.parentElement.parentElement.style.display = 'none')
                }))
          })
        : (i.length > 0 &&
            i.forEach((e) => {
              if (null != t[0]) {
                let i = t[0].value.split(' ')[0].toLowerCase()
                e.src.includes(i)
                  ? (e.parentElement.parentElement.style.display = 'block')
                  : (e.parentElement.parentElement.style.display = 'none')
              }
            }),
          n.length > 0 &&
            n.forEach((e) => {
              if (null != t[0]) {
                let i = t[0].value.split(' ')[0].toLowerCase()
                e.src.includes(i)
                  ? (e.parentElement.parentElement.style.display = 'block')
                  : (e.parentElement.parentElement.style.display = 'none')
              }
            }))
    }
  }
  updateURL() {
    this.currentVariant &&
      'false' !== this.dataset.updateUrl &&
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
  }
  updateShareUrl() {
    const e = document.getElementById(`Share-${this.dataset.section}`)
    e && e.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
  }
  updateVariantInput() {
    document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`).forEach((e) => {
      const t = e.querySelector('input[name="id"]')
      ;(t.value = this.currentVariant.id), t.dispatchEvent(new Event('change', { bubbles: !0 }))
    })
  }
  updateMaxVariantQuantity() {
    const e = new URLSearchParams(window.location.search).get('variant'),
      t = this.additionalVariantData[e],
      i = document.querySelector('.product input[name="quantity"]')
    0 == Number(i.value) && (i.value = 1),
      Number(t.inventory) > 0
        ? Number(i.value) > Number(t.inventory) && ((i.value = t.inventory), i.setAttribute('max', t.inventory))
        : Number(t.inventory) < 0 && (i.value = 1)
  }
  updatePickupAvailability() {
    const e = document.querySelector('pickup-availability')
    e &&
      (this.currentVariant && this.currentVariant.available
        ? e.fetchAvailability(this.currentVariant.id)
        : (e.removeAttribute('available'), (e.innerHTML = '')))
  }
  updateShippingFeeMessage() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((e) => e.text())
      .then((e) => {
        const t = `shipping-fee-message-${this.dataset.section}`,
          i = new DOMParser().parseFromString(e, 'text/html'),
          n = document.getElementById(t),
          s = i.getElementById(t)
        s && n && (n.innerHTML = s.innerHTML)
        const a = document.getElementById(`shipping-fee-message-${this.dataset.section}`)
        '' != a.innerHTML.trim() ? a.classList.remove('hidden') : a.classList.add('hidden')
      })
  }
  updateShippingMessage() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((e) => e.text())
      .then((e) => {
        const t = `shipping-message-${this.dataset.section}`,
          i = new DOMParser().parseFromString(e, 'text/html'),
          n = document.getElementById(t),
          s = i.getElementById(t),
          a = n.getElementsByClassName('product__store-availability__message')[0]
        s && n && (n.innerHTML = s.innerHTML)
        const r = document.getElementById(`shipping-message-${this.dataset.section}`)
        if (a) {
          r.getElementsByClassName('product__store-availability__message')[0].innerHTML = a.innerHTML
          document.getElementById(`store-availability-wrapper-${this.dataset.section}`).classList.remove('hidden')
          const e = document.querySelector('#store-locator-icon'),
            t = document.querySelector('.store-locator-opener')
          t?.addEventListener('click', (t) => {
            t.preventDefault(), e.click()
          })
        }
        '' != r.innerHTML.trim() ? r.classList.remove('hidden') : r.classList.add('hidden')
      })
  }
  updateItemModel() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((e) => e.text())
      .then((e) => {
        const t = `#product__item-model__wrapper-${this.dataset.section}`,
          i = new DOMParser().parseFromString(e, 'text/html').querySelector(t)
        document.querySelectorAll(t).forEach((e) => {
          i && e && (e.innerHTML = i.innerHTML)
          const t = e
          '' != t.innerHTML.trim() ? t.classList.remove('hidden') : t.classList.add('hidden')
        })
      })
  }
  updateWarranties() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((e) => e.text())
      .then((e) => {
        const t = `warranty-products-${this.dataset.section}`,
          i = new DOMParser().parseFromString(e, 'text/html'),
          n = document.getElementById(t),
          s = i.getElementById(t)
        s && n && (n.innerHTML = s.innerHTML)
        const a = document.getElementById(`warranty-products-${this.dataset.section}`)
        '' != a.innerHTML.trim() ? a.classList.remove('hidden') : a.classList.add('hidden')
      })
  }
  updateBogoProducts() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((e) => e.text())
      .then((e) => {
        const t = `bogo-products-${this.dataset.section}`,
          i = new DOMParser().parseFromString(e, 'text/html'),
          n = document.getElementById(t),
          s = i.getElementById(t)
        s && n && (n.innerHTML = s.innerHTML)
        const a = document.getElementById(`bogo-products-${this.dataset.section}`)
        '' != a.innerHTML.trim() ? a.classList.remove('hidden') : a.classList.add('hidden')
      })
  }
  removeErrorMessage() {
    const e = this.closest('section')
    if (!e) return
    const t = e.querySelector('product-form')
    t && t.handleErrorMessage()
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((e) => e.text())
      .then((e) => {
        const t = `#price-${this.dataset.section}`,
          i = new DOMParser().parseFromString(e, 'text/html').querySelector(t)
        document.querySelectorAll(t).forEach((e) => {
          i && e && (e.innerHTML = i.innerHTML)
          e && e.classList.remove('visibility-hidden'),
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
        })
      })
    const e = document.querySelector('#product-details')
    e &&
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${e.dataset.section}`)
        .then((e) => e.text())
        .then((t) => {
          const i = '.product-details__document-list',
            n = new DOMParser().parseFromString(t, 'text/html').querySelector(i),
            s = e.querySelector(i)
          n && s && (s.innerHTML = n.innerHTML)
        })
  }
  toggleAddButton(e = !0, t, i = !0) {
    ;[`product-form-${this.dataset.section}`, 'sticky-bar'].forEach((i) => {
      const n = document.getElementById(i)
      if (!n) return
      const s = n.querySelector('[name="add"]'),
        a = n.querySelector('[name="add"] > span')
      let r = document.querySelector('.price-item').innerText,
        o = document.querySelector('[data-hide-price]').dataset.hidePrice
      s &&
        (e
          ? (s.setAttribute('disabled', 'disabled'), t && (a.textContent = t))
          : (s.removeAttribute('disabled'),
            (a.textContent = window.variantStrings.addToCart),
            'true' != o && (a.textContent = window.variantStrings.addToCart + ' - ' + r)))
    })
  }
  setPriceLabelAddButton() {
    ;[`product-form-${this.dataset.section}`, 'sticky-bar'].forEach((e) => {
      const t = document.getElementById(e)
      if (!t) return
      const i = t.querySelector('[name="add"]'),
        n = i.querySelector('[name="add"] > span')
      let s = document.querySelector('.price-item').innerText,
        a = document.querySelector('[data-hide-price]').dataset.hidePrice
      i.hasAttribute('disabled')
        ? (n.textContent = window.variantStrings.soldOut)
        : 'true' != a && (n.textContent = window.variantStrings.addToCart + ' - ' + s)
    })
  }
  setUnavailable() {
    ;[`product-form-${this.dataset.section}`, 'sticky-bar'].forEach((e) => {
      const t = document.getElementById(e)
      if (!t) return
      const i = t.querySelector('[name="add"]'),
        n = t.querySelector('[name="add"] > span'),
        s = document.getElementById(`price-${this.dataset.section}`)
      i && ((n.textContent = window.variantStrings.unavailable), s && s.classList.add('visibility-hidden'))
    })
  }
  getVariantData() {
    return (
      (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)),
      this.variantData
    )
  }
  setColorVariantLabel() {
    let e = document.querySelector('.color_label'),
      t = document.querySelectorAll('input[name=Color]')
    for (var i = 0; i < t.length; i++) t[i].checked && (e.innerHTML += "<span class='color__variant'>: " + t[i].value + '</span>')
  }
  removeColorVariantLabel() {
    let e = document.querySelector('.color__variant')
    'undefined' !== e && null !== e && e.remove()
  }
}
customElements.define('variant-selects', VariantSelects)
class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }
  recalculateOptions() {
    const e = Array.from(this.querySelectorAll('fieldset'))
    this.options = e.map((e) => Array.from(e.querySelectorAll('input')).find((e) => e.checked).value)
  }
  updateOptions() {
    const e = Array.from(this.querySelectorAll('fieldset'))
    this.recalculateOptions()
    const t = e[e.length - 1],
      i = this.getVariantData()
    if (t && e.length > 1) {
      const n = t.dataset.optionSet,
        s = t.querySelectorAll('input'),
        a = (e) => !!this.getVariantData().find((t) => t.available && !t.options.map((t, i) => e[i] === t).includes(!1)),
        r = (e) => {
          let t = this.options.slice()
          return (
            (t[n] = e),
            !!i.find((e) => e.available && e.option1 == t[0] && e.option2 == t[1] && (!e.option3 || e.option3 == t[2]))
          )
        }
      s.forEach((e) => {
        r(e.value) ? e.classList.remove('unavailable') : e.classList.add('unavailable')
      })
      e[e.length - 2].querySelectorAll('input').forEach((t) => {
        let i = this.options.slice()
        i[e.length - 2] = t.value
        Array.from(s).every((t) => ((i[e.length - 1] = t.value), !a(i)))
          ? t.classList.add('unavailable')
          : t.classList.remove('unavailable')
      })
      if (!r(this.options[n])) {
        let e
        s.forEach((t) => {
          t.classList.contains('unavailable') || (e = t)
        }),
          e && ((this.options[n] = e.value), (e.checked = !0))
      }
      e.forEach((e) => {
        const t = Array.from(e.querySelectorAll('input'))
        if (t.find((e) => e.checked).classList.contains('unavailable')) {
          const e = t.find((e) => !e.classList.contains('unavailable'))
          e && (e.checked = !0)
        }
      }),
        this.recalculateOptions(),
        s.forEach((e) => {
          r(e.value) ? e.classList.remove('unavailable') : e.classList.add('unavailable')
        })
      const o = Array.from(s)?.filter((e) => !e.classList.contains('unavailable'))
      1 == o.length && ((o[0].checked = !0), this.recalculateOptions())
    }
  }
}
customElements.define('variant-radios', VariantRadios)
const quantityInput = document.querySelector('.product input[name="quantity"]')
function onNavLink(e) {
  !!('touchstart' === e.type) || e.target.matches(':hover')
    ? (this.parentElement.parentElement.querySelectorAll('.header__submenu-has-children, .no-grandchildren').forEach((e) => {
        e.classList.remove('is-open'), e.setAttribute('aria-expanded', 'false')
      }),
      this.classList.add('is-open'),
      this.setAttribute('aria-expanded', 'true'))
    : ('Enter' != e.key && ' ' != e.key) ||
      (this.parentElement.parentElement.querySelectorAll('.header__submenu-has-children, .no-grandchildren').forEach((e) => {
        e.classList.remove('is-open'), e.setAttribute('aria-expanded', 'false')
      }),
      this.classList.contains('is-open')
        ? (this.classList.remove('is-open'), this.setAttribute('aria-expanded', 'false'))
        : (this.classList.add('is-open'), this.setAttribute('aria-expanded', 'true')))
}
quantityInput &&
  quantityInput.addEventListener('change', function () {
    let e = quantityInput.getAttribute('max')
    null != e && Number(quantityInput.value) > e && (quantityInput.value = 0 != e ? e : 1)
  }),
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth > 990) {
      const e = document.querySelectorAll('.header__submenu--left-rail.header__link-lists .header__submenu-has-children'),
        t = document.querySelectorAll('.header__submenu--left-rail.header__link-lists .no-grandchildren'),
        i = document.querySelectorAll('.header__submenu--left-rail.header__link-lists a')
      e.forEach((e) => {
        e.addEventListener('mouseover', onNavLink),
          e.addEventListener('touchstart', onNavLink),
          e.addEventListener('keypress', onNavLink)
      }),
        t.forEach((e) =>
          e.addEventListener('mouseover', (e) => {
            e.target.matches(':hover') &&
              (e.target.parentElement.parentElement.querySelectorAll('.is-open').forEach((e) => e.classList.remove('is-open')),
              e.target.classList.add('is-open'))
          })
        ),
        i.forEach((e) =>
          e.addEventListener('touchstart', (e) => {
            e.preventDefault()
            'touchstart' === e.type && e.target.click()
          })
        )
    }
  }),
  document.addEventListener('DOMContentLoaded', () => {
    const e = document.querySelector('html'),
      t = document.querySelector('body'),
      i = document.querySelector('.ss__search-mobile')
    document.ontouchmove = (e) => e.preventDefault()
    const n = () => {
        t.classList.add('overflow-hidden'),
          (t.style.height = '100vh'),
          e.classList.add('overflow-hidden'),
          (e.style.height = '100vh')
      },
      s = () => {
        const i = document.querySelector('cart-drawer'),
          n = document.querySelector('store-details-drawer'),
          s = document.querySelector('account-menu-drawer')
        i.classList.contains('active') ||
          n.classList.contains('active') ||
          s.classList.contains('active') ||
          (t.classList.remove('overflow-hidden'),
          (t.style.height = ''),
          e.classList.remove('overflow-hidden'),
          (e.style.height = ''))
      }
    document.addEventListener('click', () => {
      document.activeElement == i ? n() : s()
    }),
      i.addEventListener('focus', () => {
        n()
      }),
      window.addEventListener('resize', () => {
        document.querySelector('.ss__autocomplete') && (window.innerWidth < 990 ? n() : s())
      })
    const a = document.querySelectorAll('.search .search__input'),
      r = (document.querySelectorAll('.search .search__button'), document.querySelectorAll('.search .close__button'))
    a.forEach((e) => {
      r.forEach((t) => {
        t.addEventListener('click', () => {
          ;(e.value = ''), (t.style.display = 'none')
        })
      }),
        e.addEventListener('focus', () => {
          r.forEach((e) => {
            e.style.display = 'block'
          })
        }),
        e.addEventListener('blur', (t) => {
          t.relatedTarget?.classList?.contains('close__button') && (e.value = ''),
            '' == e.value && r.forEach((e) => (e.style.display = 'none'))
        })
    })
  })
let vh = 0.01 * window.innerHeight
document.documentElement.style.setProperty('--vh', `${vh}px`),
  window.addEventListener('resize', () => {
    let e = 0.01 * window.innerHeight
    document.documentElement.style.setProperty('--vh', `${e}px`)
  }),
  window.addEventListener('orientationchange', () => {
    let e = 0.01 * window.innerHeight
    document.documentElement.style.setProperty('--vh', `${e}px`)
  }),
  document.addEventListener('DOMContentLoaded', () => {
    const e = document.querySelector('.view-more-button')
    e &&
      e.addEventListener('click', (t) => {
        const i = document.querySelector(e.getAttribute('href'))
        if (i) {
          t.preventDefault()
          const e = -60,
            n = i.getBoundingClientRect().top + window.scrollY
          window.scrollTo({ top: n + e, behavior: 'smooth' })
        }
      })
  })
